/**
 * requestNumber.ts — Sprint 147 (ADR-142, R14-24).
 *
 * Maintenance requests created through the UI were numbered `MR-<epoch>`
 * (`MR-1784513182486`) by the store slice, while the seed and the
 * MaintenanceRequests page both use the human convention `MR-<year>-<4 digits>`
 * (`MR-2026-2001`). Two generators, two formats, one list — so the same table
 * showed both. One generator now, shared by every caller.
 *
 * Not a server-allocated sequence: the backend accepts a client-supplied
 * `requestNumber` and nothing today allocates one centrally, so this stays a
 * client-side format with a random suffix (collisions are possible but
 * cosmetic — `id` is the key). Promoting it to a real per-condo sequence is a
 * backend change and is out of scope for this Low finding.
 */
import dayjs from 'dayjs';

/** `MR-<current year>-<4 digits>`, e.g. `MR-2026-2001`. */
export function generateMaintenanceRequestNumber(): string {
  return `MR-${dayjs().format('YYYY')}-${String(Math.floor(1000 + Math.random() * 9000))}`;
}
